import { connect } from 'react-redux';
import { restrictLoggedOut } from '../redux/loggedout/actionCreators';
const mapStateToProps = (state)=>({});
const mapDispatchToProps = {
    restrictLoggedOut
};
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=SisuFunnelBanner.container.js.map